<template>
  <div v-if="solic">
    <h4 v-if="solic"># de solicitud: {{ solic.id_solic }}</h4>
    <v-alert v-if="solic" :type="tipoAlerta"> {{ observaciones }}</v-alert>
    <v-btn small color="red" @click="$emit('exit')" v-if="!mostrarpractica"
      >Cancelar</v-btn
    >
    <div v-if="solic && mostrarpractica">
      <Practica readonly :solic="solic" @guardado="$emit('exit')"></Practica>
    </div>
  </div>
</template>

<script>
import API from "@/lib/API";
import Practica from "@/components/Practica/Practica";
export default {
  props: {
    id_efector: Number,
    id_solic: Number,
  },
  components: {
    Practica,
  },
  data() {
    return {
      solic: null,
      observaciones: "",
      mostrarpractica: false,
      tipoAlerta: "success",
    };
  },
  methods: {
    evaluar() {
      let obs = "";
      this.tipoAlerta = "error";
      this.mostrarpractica = false;
      if (this.solic) {
        if (this.solic.id_efector != this.id_efector) {
          obs += " * La practica corresponde a otro Prestador";
        } else {
          this.mostrarpractica = true;
          obs += "* La practica esta ";
          const venc = new Date();
          venc.setDate(venc.getDate() - 30);
          if (new Date(this.solic.fecha) < venc) {
            obs += " VENCIDA";
          } else {
            switch (this.solic.estado) {
              case 1:
                obs += "PENDIENTE";
                break;
              case 2:
                obs += "AUTORIZADA";
                this.tipoAlerta = "success";
                break;
              case 3:
                obs += "EN GESTION";
                break;
              case 4:
                obs += "RECHAZADA";
                break;
              case 5:
                obs += "FINALIZADA";
                break;

              default:
                break;
            }
          }
        }
      }
      this.observaciones = obs;
    },
  },
  // computed: {
  //   tipoAlerta() {
  //     let ret = "success";
  //     if (this.solic) {
  //       const venc = new Date();
  //       venc.setDate(venc.getDate() - 3);
  //       if (
  //         this.solic.id_efector != this.id_efector ||
  //         this.solic.estado != 2 ||
  //         new Date(this.solic.fecha) < venc
  //       ) {
  //         ret = "error";
  //       }
  //     }
  //     return ret;
  //   },
  //   mostrarpractica() {
  //     let ret = true;
  //     if (this.solic) {
  //       if (this.solic.id_efector != this.id_efector) {
  //         ret = false;
  //       }
  //     }
  //     return ret;
  //   },
  //   observaciones() {
  //     let ret = "";
  //     if (this.solic) {
  //       if (this.solic.id_efector != this.id_efector) {
  //         ret += " * La practica corresponde a otro Prestador";
  //       } else {
  //         ret += "* La practica esta ";
  //         const venc = new Date();
  //         venc.setDate(venc.getDate() - 3);
  //         if (new Date(this.solic.fecha) < venc) {
  //           ret += " VENCIDA";
  //         } else {
  //           switch (this.solic.estado) {
  //             case 1:
  //               ret += "PENDIENTE";
  //               break;
  //             case 2:
  //               ret += "AUTORIZADA";
  //               break;
  //             case 3:
  //               ret += "EN GESTION";
  //               break;
  //             case 4:
  //               ret += "RECHAZADA";
  //               break;
  //             case 5:
  //               ret += "FINALIZADA";
  //               break;

  //             default:
  //               break;
  //           }
  //         }
  //       }
  //     }
  //     return ret;
  //   },
  // },
  watch: {
    async id_solic() {
      if (this.id_solic) {
        this.solic = await API.Autorizaciones.traerUna(this.id_solic);
        this.evaluar();
      }
      else
      {
        this.solic = undefined;
      }
    },
  },
};
</script>

<style></style>
